import HeaderComponent from "../../components/header/headerComponent";
import { useTranslation } from "react-i18next";
import ProductPage from "./ProductPage";

const ProductMainPage = () => {
  const { t } = useTranslation();
  return (
    <>
    <HeaderComponent pageTitle={t('Product Management')} >
      <ProductPage  />
    </HeaderComponent>
    </>
  )
}

export default ProductMainPage